import { render, staticRenderFns } from "./transparenciaOne.vue?vue&type=template&id=26cc42e2"
import script from "./transparenciaOne.vue?vue&type=script&lang=js"
export * from "./transparenciaOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports